var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
export var initState = {
  savedStyles: {}
};
var reducers = function reducers(state, action) {
  var _a;
  if (state === void 0) {
    state = initState;
  }
  switch (action.type) {
    case 'saveStyle':
      {
        return __assign(__assign({}, state), {
          savedStyles: __assign(__assign({}, state.savedStyles), action.payload)
        });
      }
    case 'resetStyle':
      {
        return __assign(__assign({}, state), {
          savedStyles: __assign(__assign({}, state.savedStyles), (_a = {}, _a[action.payload.component] = {}, _a))
        });
      }
    case 'updateStyle':
      {
        var savedStyles_1 = action.payload;
        Object.keys(state.savedStyles).forEach(function (key) {
          if (!savedStyles_1[key]) {
            savedStyles_1[key] = '';
          }
        });
        return __assign({}, savedStyles_1);
      }
    default:
      return state;
  }
};
export default reducers;